import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  getLatestSignatureRequest,
  SignatureRequest,
} from '@app/features/contracts/signature/signature-request.model';
import { Observable } from 'rxjs';
import { AsyncMatIconButton } from '../async-mat-icon-button/async-mat-icon-button';

@Component({
  selector: 'app-yousign-button',
  imports: [CommonModule, MatButtonModule, MatIconModule, AsyncMatIconButton, MatTooltipModule],
  templateUrl: './yousign-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './yousign-button.scss',
})
export class YousignButton<T> {
  ariaLabel = input.required<string>();
  signatureRequests = input<SignatureRequest[]>();

  @Input({ required: true }) action!: Observable<T>;
  @Output() actionResult = new EventEmitter<T>();

  get isAvailable() {
    const requests = this.signatureRequests();
    if (!requests?.length) return true;

    // Une demande expirée appelle un renvoi ; une demande restée en brouillon n'a pas été confirmée
    // par Yousign, et le renvoi la vérifie d'abord (RG-signature-activation-incertaine).
    const latestByExpiration = getLatestSignatureRequest(requests);
    return latestByExpiration?.status === 'expired' || latestByExpiration?.status === 'draft';
  }
}
